import { createFileRoute } from '@tanstack/react-router';
import { PaymentsSettingsPage } from '@/features/checkout/pages/payments-settings-page';

export const Route = createFileRoute('/_app/settings/payments')({ component: PaymentsSettingsPage });
